import React from 'react';
import { StarIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, testimonials } from '../data/content';
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="bg-noche" data-id="element-164" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-2xl px-3 py-5 text-center sm:px-5" data-id="element-165" data-mp="3b146nhllnt7f">
        <h2 id="testimonios" className="font-display text-[1.6rem] uppercase leading-[1.08] text-white sm:text-4xl" data-id="element-166" data-mp="3ayqb77n0cezc">
          Lo que dicen{' '}
          <span className="text-oro" data-id="element-167" data-mp="31yl4kzpn1km8">quienes ya empezaron</span>
        </h2>
        <p className="mx-auto mt-1 max-w-xl text-sm leading-snug text-white/90" data-id="element-168" data-mp="2x1kzar0m4lw6">
          De buscar materiales durante horas a tener contenidos, actividades y
          evaluaciones organizados.
        </p>

        <ul className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-169" data-mp="v8wsk7orfgbn">
          {testimonials.map((t, i) => <Reveal key={t.author} as="li" delay={i * 0.03} className={`flex h-full flex-col rounded-xl border-2 border-ciencia bg-white p-2.5 text-left text-noche-dark ${i === testimonials.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-170" data-mp="qava9oz5rl18" data-mpi={i}>
              <div className="flex items-start justify-between gap-2" data-id="element-171" data-mp="7a4xozqmtrny">
                <span className="font-sub text-[11px] font-extrabold leading-tight text-noche" data-id="element-172" data-mp="c7dgn2jltzq9">
                  {t.label}
                </span>
                <div className="flex flex-shrink-0 gap-0.5" aria-label="5 de 5 estrellas" data-id="element-173" data-mp="14v9cy659hpmi">
                  {Array.from({
                length: 5
              }).map((_, j) => <StarIcon key={j} size={13} className="fill-oro text-oro-dark" data-id="element-174" data-mp="q63c6dqrzrci" data-mpi={j} />)}
                </div>
              </div>
              <blockquote className="mt-1 text-xs italic leading-snug sm:text-sm" data-id="element-175" data-mp="1nm0h8tae6pu1">
                “{t.quote}”
              </blockquote>
              <p className="mt-auto pt-1.5 font-sub text-sm font-extrabold text-noche" data-id="element-176" data-mp="1xi8z0ytsiv89">
                {t.author}{' '}
                <span className="font-sans text-xs font-semibold text-noche-dark/70" data-id="element-177" data-mp="1sjfn3au5jca7">
                  · {t.detail}
                </span>
              </p>
            </Reveal>)}
        </ul>

        <CtaButton href={OFFER_ANCHOR} className="mt-4" data-id="element-178" data-mp="1jhpui1oja7au">
          🚀 Sí, quiero acceder ahora
        </CtaButton>
        <p className="mt-2.5 text-xs font-semibold text-white/85" data-id="element-179" data-mp="1el7utg828z5d">
          Acceso Inmediato • Garantía de 7 Días
        </p>
      </div>
    </section>;
}